import { render, staticRenderFns } from "./AdminCopperCate2.vue?vue&type=template&id=66fed319&scoped=true&"
import script from "./AdminCopperCate2.vue?vue&type=script&lang=js&"
export * from "./AdminCopperCate2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fed319",
  null
  
)

export default component.exports